import React from "react";

import { rowAmountText } from "./format";
import { Amount } from "./styles";
import { ProgressAmountProps } from "./types";

const toneOf = ({ amount, isNeutral }: ProgressAmountProps["row"]) => {
  if (isNeutral) {
    return "neutral";
  }
  return amount > 0 ? "positive" : "negative";
};

export const ProgressAmount: React.FC<ProgressAmountProps> = ({ row }) => (
  <Amount $tone={toneOf(row)}>{rowAmountText(row)}</Amount>
);
